/**
 * Accessible ARIA Tabs Switching for Care Packages block
 */

export const initPackagesTabs = () => {
	const container = document.querySelector('[data-tabs-container]');
	if (!container) return;

	const tabs = container.querySelectorAll('[role="tab"]');
	const panels = container.querySelectorAll('[role="tabpanel"]');

	if (!tabs.length || !panels.length) return;

	const switchTab = (targetTab) => {
		const targetPanelId = targetTab.getAttribute('aria-controls');

		tabs.forEach((tab) => {
			const isSelected = tab === targetTab;
			tab.setAttribute('aria-selected', String(isSelected));
			tab.tabIndex = isSelected ? 0 : -1;

			const tabImg = tab.querySelector('img');

			if (isSelected) {
				tab.classList.remove('border-border', 'bg-background', 'text-body', 'hover:text-primary', 'bg-teal-soft', 'hover:text-secondary');
				tab.classList.add('border-primary', 'bg-primary', 'text-primary-foreground');
				if (tabImg) {
					tabImg.style.filter = 'brightness(0) invert(1)';
				}
			} else {
				tab.classList.remove('border-primary', 'bg-primary', 'text-primary-foreground');
				tab.classList.add('border-border', 'bg-background', 'text-body', 'hover:text-primary');
				if (tabImg) {
					tabImg.style.filter = '';
				}
			}
		});

		panels.forEach((panel) => {
			if (panel.id === targetPanelId) {
				panel.classList.remove('hidden');
			} else {
				panel.classList.add('hidden');
			}
		});
	};

	tabs.forEach((tab, index) => {
		tab.addEventListener('click', () => switchTab(tab));

		tab.addEventListener('keydown', (e) => {
			let nextIndex = index;
			if (e.key === 'ArrowRight') {
				nextIndex = (index + 1) % tabs.length;
			} else if (e.key === 'ArrowLeft') {
				nextIndex = (index - 1 + tabs.length) % tabs.length;
			} else if (e.key === 'Home') {
				nextIndex = 0;
			} else if (e.key === 'End') {
				nextIndex = tabs.length - 1;
			} else {
				return;
			}

			e.preventDefault();
			tabs[nextIndex].focus();
			switchTab(tabs[nextIndex]);
		});
	});
};

if (typeof document !== 'undefined') {
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initPackagesTabs);
	} else {
		initPackagesTabs();
	}
}

